import { Navigate } from 'react-router-dom';
import { useAuthStore, type UserRole } from '@/store/authStore';
import { holdsAnyRole } from '@/lib/roles';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Any one of these is enough. */
  roles?: UserRole[];
}

export function ProtectedRoute({ children, roles }: ProtectedRouteProps) {
  const { isAuthenticated, user, getEffectiveRoles } = useAuthStore();
  const effectiveRoles = getEffectiveRoles();

  if (!isAuthenticated || !user) {
    return <Navigate to="/auth/login" replace />;
  }

  // Holding *any* of the named offices is enough, and the check reads the whole
  // set rather than one primary role: a teacher whose own child attends the
  // school holds `parent` too, and gating on their primary role alone would shut
  // them out of the parent pages they are entitled to. Effective rather than
  // actual, so impersonation still shows what that person sees.
  if (roles && !holdsAnyRole(effectiveRoles, roles)) {
    return <Navigate to={`/${user.schoolSlug}/dashboard`} replace />;
  }

  return <>{children}</>;
}
